import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API, useApp } from "@/context/AppContext";
import { thumb } from "@/lib/helpers";
import { ArrowRight } from "lucide-react";

const fmtDate = (d, lang) => {
  if (!d) return "";
  try { return new Date(d).toLocaleDateString(lang === "en" ? "en-US" : "es-MX", { day: "numeric", month: "long", year: "numeric" }); }
  catch { return ""; }
};

export const NewsBlock = () => {
  const { lang } = useApp();
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog?limit=3`).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20" data-testid="news-block">
      <div className="flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading uppercase text-3xl sm:text-4xl text-[#16221D]">
            {lang === "en" ? "News" : "Noticias"}
          </h2>
          <p className="mt-2 text-[#5E6D64] text-sm md:text-base">
            {lang === "en" ? "Stories, tips and news from the trail" : "Historias, consejos y novedades desde la montaña"}
          </p>
        </div>
        <Link to="/blog" data-testid="news-see-all"
          className="hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold text-[#6E7E56] hover:text-[#D94E28] transition-colors duration-300">
          {lang === "en" ? "See all" : "Ver todas"} <ArrowRight className="h-4 w-4" />
        </Link>
      </div>

      <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((p) => (
          <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`news-card-${p.slug}`}
            className="group rounded-2xl overflow-hidden bg-white border border-[#E2DFD7] hover:shadow-lg transition-shadow duration-300">
            <div className="aspect-[16/10] overflow-hidden bg-[#E2DFD7]">
              {p.cover ? (
                <img src={thumb(p.cover, 640)} alt={p.title} loading="lazy"
                  className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
              ) : null}
            </div>
            <div className="p-5">
              <p className="text-[11px] uppercase tracking-widest text-[#8A968E]">{fmtDate(p.published_at, lang)}</p>
              <h3 className="mt-2 font-semibold text-[#16221D] text-lg leading-snug line-clamp-2">{p.title}</h3>
              {p.excerpt && <p className="mt-2 text-sm text-[#5E6D64] line-clamp-2">{p.excerpt}</p>}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
